import { getStates } from "@/api/states";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { statesKeys } from "./keys";
import { States } from "./schema";

const defaultStatesQueryOptions = {
	staleTime: Number.POSITIVE_INFINITY,
	refetchOnWindowFocus: false,
	gcTime: Number.POSITIVE_INFINITY,
} as const;

export function getStatesQueryOptions(
	countryId: number,
	options?: QueryOptionsWithoutKeyAndFn<States>,
) {
	return queryOptions({
		queryKey: statesKeys.states(countryId),
		queryFn: () => getStates(countryId),
		...defaultStatesQueryOptions,
		...options,
	});
}

export default function useGetStates(
	countryId: number,
	options?: QueryOptionsWithoutKeyAndFn<States>,
) {
	return useQuery(getStatesQueryOptions(countryId, options));
}
